// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__QFcpN","spinner":"Spinner_spinner__6Ig9D","spin":"Spinner_spin__GJtSS","small":"Spinner_small__v0b56"};